export enum VerticalRouteType {
  Sales = 'sales',
  Finance = 'finance',
  Leasing = 'leasing',
}
